// @ts-nocheck

import { BasketActionTypes } from '../../../types/actions/basket';

export const basketItemSetIsGRActive = ({ oddsId, isGRActive }) => ({
  type: BasketActionTypes.SET_ITEM_IS_GR_ACTIVE,
  payload: {
    oddsId,
    isGRActive,
  },
});

export const basketSetIsGRActive = ({ isGRActive }) => ({
  type: BasketActionTypes.SET_IS_GR_ACTIVE,
  payload: {
    isGRActive,
  },
});

export const resetAllGRActives = () => ({
  type: BasketActionTypes.RESET_ALL_GR_ACTIVES,
});

export const recomputeNextGRBasketState = () => ({
  type: BasketActionTypes.RECOMPUTE_NEXT_GR_BASKET_STATE,
});
